import { gql } from '@apollo/client'
import ORGANIZATION_WITH_ID_NAME_TPA_FRAGMENT from 'apollo/fragments/ORGANIZATION_WITH_ID_NAME_TPA_FRAGMENT'

// MEMBER_BY_ID

export default gql`
  query memberById($id: ID!) {
    member(id: $id) {
      id
      first_name
      last_name
      dob
      register_status
      organization_live
      organization {
        ...ORGANIZATION_WITH_ID_NAME_TPA_FRAGMENT
      }
    }
  }
  ${ORGANIZATION_WITH_ID_NAME_TPA_FRAGMENT}
`
